
  document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll("[data-pdp-accordion-container]");
  // console.log('accordion taggggggggggggggggggggggggggg')
    accordions.forEach((accordion, index) => {
      const content = accordion.querySelector(".pdp-accordion__content");

      // If content exists, check if it's visually empty
      if (content) {
        const cleanedHTML = content.innerHTML
          .replace(/<p>(&nbsp;|\s|<\/?p>)*<\/p>/gi, '') // remove empty <p> tags
          .replace(/<[^>]+>/g, '')                      // strip remaining tags
          .trim();

        if (cleanedHTML === '') {
          // Remove active class and hide it
          accordion.classList.remove("active");
          accordion.style.display = "none";

          // Activate the next visible accordion, if any
          const nextAccordion = accordions[index + 1];
          if (nextAccordion) {
            nextAccordion.classList.add("active");
            const heading = nextAccordion.querySelector("[data-pdp-accordion-heading]");
            if (heading) heading.setAttribute("aria-expanded", "true");
          }
        }
      }
    });
  });

